<app-carousel>
  <ng-template carouselItem="1">
    <mat-card appearance="outlined" class="mat-card-c mt-3">
      <mat-card-content class="mat-body-1">
        <h1><strong>Resumen</strong></h1>
        <h3 class="reduced-line-height">Número de orden: {{ data.consecutive }}</h3>
        <h3 class="reduced-line-height">Cliente: {{ data.providerName }}</h3>
        <h3 class="reduced-line-height">Dirección cliente: {{ data.providerAddress }}</h3>
        <h3 class="reduced-line-height">Fecha Inicio: {{ data.startDate }}</h3>
        <h3 class="reduced-line-height">Fecha Fin: {{ data.endDate }}</h3>
        <h3 class="reduced-line-height">Estado Actual: {{ data.stateName }}</h3>
        <hr />
        <h1><strong>Estados</strong></h1>

        <h2>Despacho de bodega</h2>
        <ul>
          <li>Fecha: {{ data.dispatchDate }}</li>
          <li>Usuario: {{ data.userDispatchName }}</li>
          <li>Comentario: {{ data.dispatchComment }}</li>
        </ul>

        <h2>Entregar al Cliente</h2>
        <ul>
          <li>Fecha: {{ data.state2Date }}</li>
          <li>Usuario: {{ data.userState2Name }}</li>
          <li>Comentario: {{ data.state2Comment }}</li>
        </ul>

        <h2>Recoger al Cliente</h2>
        <ul>
          <li>Fecha: {{ data.state3Date }}</li>
          <li>Usuario: {{ data.userState3Name }}</li>
          <li>Comentario: {{ data.state3Comment }}</li>
        </ul>

        <h2>Entregar Bodega</h2>
        <ul>
          <li>Fecha: {{ data.incomeDate }}</li>
          <li>Usuario: {{ data.userIncomeName }}</li>
          <li>Comentario: {{ data.incomeComment }}</li>
        </ul>

        <hr />
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template carouselItem="2">
    <mat-card appearance="outlined" class="mat-card-c">
      <mat-card-content class="mat-body-1">
        <h2 style="display: flex; justify-content: center">
          <strong>EQUIPOS </strong>
        </h2>
        <data-table
          [title]=""
          [columns]="columnsEquipments"
          [configuration]="configurationEquipments"
          [data]="dataEquipments"
        >
        </data-table>
      </mat-card-content>
    </mat-card>
  </ng-template>
</app-carousel>